import { render, staticRenderFns } from "./AcuvueCard.vue?vue&type=template&id=ee2d7b88&scoped=true&"
import script from "./AcuvueCard.vue?vue&type=script&lang=js&"
export * from "./AcuvueCard.vue?vue&type=script&lang=js&"
import style0 from "./AcuvueCard.vue?vue&type=style&index=0&id=ee2d7b88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2d7b88",
  null
  
)

export default component.exports